import { errorFlags, useFlagsService } from '@atlassian/jira-flags';
import { useIntl } from '@atlassian/jira-intl';
import { type MenuNode, MenuNodeType } from '@atlassian/jira-software-context-menu';
import { COPY_ISSUE_KEY_MENU_ID } from '../../constants';
import messages from '../../messages';
import type { Props } from './types';

export const useCopyIssueKey = ({ issueKey, selectedCardIds }: Props): MenuNode[] => {
	const { formatMessage } = useIntl();
	const { showFlag } = useFlagsService();

	if (selectedCardIds.length > 1) return [];

	const onCopyIssueKey = () =>
		navigator.clipboard
			.writeText(issueKey)
			.then(() => {
				showFlag({
					type: 'success',
					title: messages.copyIssueKeySuccessTitle,
					description: messages.copyIssueKeySuccessDescription,
				});
			})
			.catch(() => {
				showFlag(errorFlags.genericError());
			});

	return [
		{
			type: MenuNodeType.Item,
			label: formatMessage(messages.copyIssueKey),
			id: COPY_ISSUE_KEY_MENU_ID,
			onClick: onCopyIssueKey,
		},
	];
};
